"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoudspeakerClient = void 0;

var _baseclient = require("./baseclient");

var _definitions = require("../components/model/definitions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const LOUDSPEAKER_BASE_URL_PRODUCTION = 'https://api.loudspeaker.cimpress.io';
const LOUDSPEAKER_BASE_URL_STAGING = 'https://int-api.loudspeaker.cimpress.io';
const SESSION_BASE_URL = 'https://sessions.cimpress.io';

class LoudspeakerClient extends _baseclient.BaseClient {
  constructor(settings, env) {
    super(settings);
    this.baseUrl = env === _definitions.ServiceEnvironment.Production ? LOUDSPEAKER_BASE_URL_PRODUCTION : LOUDSPEAKER_BASE_URL_STAGING;
    this.accessToken = settings.accessToken;
  }

  async getAnnouncements(queryParameters) {
    const announcementList = [];

    if (this.channelIds.length > 4) {
      console.warn('Loudspeaker: react-Loudspeaker supports viewing announcements from a maximum of 4 channels.' + ' Please lower the number of channels you are querying to 4 or below.');
      return announcementList;
    } // eslint-disable-next-line no-restricted-syntax


    for (const channelId of this.channelIds) {
      let announcementUrl = `${this.baseUrl}/v2/channels/${channelId}/announcements`;
      let channelUrl = `${this.baseUrl}/v1/channels/${channelId}`;
      let fetchMethod = 'get';

      if (queryParameters) {
        var _queryParameters$afte;

        announcementUrl = `${announcementUrl}?after=${encodeURIComponent((_queryParameters$afte = queryParameters.after[channelId]) !== null && _queryParameters$afte !== void 0 ? _queryParameters$afte : '2001-01-01T01:01:01Z')}`;
      }

      if (!this.accessToken) {
        // reset variables to proxy values
        announcementUrl = `${SESSION_BASE_URL}/v1/sessions/proxy?proxyUrl=${encodeURIComponent(announcementUrl)}&proxyUrlMethod=${fetchMethod}`;
        channelUrl = `${SESSION_BASE_URL}/v1/sessions/proxy?proxyUrl=${channelUrl}&proxyUrlMethod=${fetchMethod}`;
        fetchMethod = 'post';
      }

      try {
        const responses = await Promise.all([fetch(announcementUrl, _objectSpread({
          method: fetchMethod,
          headers: this.headers
        }, !this.accessToken && {
          body: JSON.stringify({})
        })), fetch(channelUrl, _objectSpread({
          method: fetchMethod,
          headers: this.headers
        }, !this.accessToken && {
          body: JSON.stringify({})
        }))]);

        if (!responses[0].ok || !responses[1].ok) {
          throw new Error(`Loudspeaker: Unable to retrieve announcements from ${channelId}`);
        }

        const results = await Promise.all([responses[0].json(), responses[1].json()]);
        results[0].forEach(a => announcementList.push(a));
      } catch (error) {
        console.warn(error.message);
      }
    }

    return announcementList;
  }

}

exports.LoudspeakerClient = LoudspeakerClient;